import React, { useEffect, useState, useRef } from 'react';

// Import SVG assets
import BackgroundSVG from '../assets/vectors/nameCard/bgd_sally.svg';
import EmailIcon from '../assets/vectors/nameCard/icn_email.svg';
import InstagramIcon from '../assets/vectors/nameCard/icn_instagram.svg';
import LinkedinIcon from '../assets/vectors/nameCard/icn_linkedin.svg';
import WhatsappIcon from '../assets/vectors/nameCard/icn_whatsapp.svg';
import GenomiiWebsiteButton from '../assets/vectors/nameCard/btn_genomiiwebsite.svg';
import ScheduleMeetingButton from '../assets/vectors/nameCard/btn_schedulemeeting.svg';
import YoutubeChannelButton from '../assets/vectors/nameCard/btn_youtubechannel.svg';

const SallyNamecard = () => {
  const containerRef = useRef(null);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  
  // Links for each icon and button
  const links = {
    schedule: '/meeting',//https://kdz2ecuce1a.sg.larksuite.com/scheduler/59dd903ec6bea5ea
    youtube: 'https://www.youtube.com/@SallyTheDnaDiva',
    whatsapp: 'data:text/vcard;charset=utf-8,BEGIN%3AVCARD%0AVERSION%3A3.0%0AN%3ASally%20So%0AFN%3ASally%20So%0ATEL%3A%E2%80%AA%2B16047808162%E2%80%AC%0AEMAIL%3Asally%40genomii.ai%0AEND%3AVCARD',//https://wa.me/16047808162?text=Great to connect with you!
    linkedin: 'https://www.linkedin.com/in/sallyshanniso/',
    instagram: 'https://www.instagram.com/sallythednadiva/',
    email: 'mailto:sally@genomii.ai',
    website: 'https://genomii.ai'
  };

  // Calculate container size on mount and resize
  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        // Calculate size based on viewport aspect ratio
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        
        let width, height;
        
        // If viewport is taller than 16:9 ratio
        if (viewportWidth / viewportHeight < 9 / 16) {
          // Use full width and calculate height
          width = viewportWidth;
          height = viewportWidth * (16 / 9);
        } else {
          // Use full height and calculate width
          height = viewportHeight;
          width = viewportHeight * (9 / 16);
        }
        
        setContainerSize({ width, height });
      }
    };

    // Initial calculation
    updateSize();
    
    // Add event listener for window resize
    window.addEventListener('resize', updateSize);
    
    // Clean up
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  // Calculate icon and button sizes based on container width
  const iconSize = containerSize.width * 0.08; // 8% of container width
  const buttonWidth = containerSize.width * 0.8; // 80% of container width

  const containerStyle = {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundColor: '#f8f8f8'
  };

  const namecardStyle = {
    width: `${containerSize.width}px`,
    height: `${containerSize.height}px`,
    position: 'relative',
    aspectRatio: '9/16'
  };

  const backgroundStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  };

  const contentOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const iconRowStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: `${containerSize.width * 0.03}px`, // Space between icons
    marginTop: `${containerSize.height * 0.62}px`, // Position at 55% from top
  };

  const iconStyle = {
    width: `${iconSize}px`,
    height: `${iconSize}px`
  };

  const buttonColumnStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: `${containerSize.height * 0.03}px`,
    marginTop: `${containerSize.height * 0.05}px`
  };

  const buttonStyle = {
    width: `${buttonWidth}px`
  };

  return (
    <div style={containerStyle} ref={containerRef}>
      <div style={namecardStyle}>
        {/* Background SVG */}
        <img 
          src={BackgroundSVG} 
          alt="Background" 
          style={backgroundStyle}
        />
        
        {/* Content overlay */}
        <div style={contentOverlayStyle}>
          {/* Icon row */}
          <div style={iconRowStyle}>
            <a href={links.instagram} target="_blank" rel="noopener noreferrer">
              <img src={InstagramIcon} alt="Instagram" style={iconStyle} />
            </a>
            <a href={links.linkedin} target="_blank" rel="noopener noreferrer">
              <img src={LinkedinIcon} alt="LinkedIn" style={iconStyle} />
            </a>
            <a href="mailto:sally@genomii.ai">
              <img src={EmailIcon} alt="Email" style={iconStyle} />
            </a>
            {/* hax whatsapp to a name card*/}
            <a href={links.whatsapp} className="add-btn" download="Sally So.vcf" target="_blank" rel="noopener noreferrer"> 
              <img src={WhatsappIcon} alt="WhatsApp" style={iconStyle} />
            </a>
          </div>
          
          {/* Button column */}
          <div style={buttonColumnStyle}>
            <a href={links.youtube} target="_blank" rel="noopener noreferrer">
              <img src={YoutubeChannelButton} alt="YouTube Channel" style={buttonStyle} />
            </a>
            <a href={links.website} target="_blank" rel="noopener noreferrer">
              <img src={GenomiiWebsiteButton} alt="Genomii Website" style={buttonStyle} />
            </a>
            <a href={links.schedule} target="_blank" rel="noopener noreferrer">
              <img src={ScheduleMeetingButton} alt="Schedule Meeting" style={buttonStyle} />
            </a>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default SallyNamecard;